export default "__VITE_ASSET__d5497ab3__"